(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{const close=event.target.closest('[data-pv-filter-close]');if(close){const menu=close.closest('.pv-filter-disclosure');menu.open=false;menu.querySelector('summary').focus();}document.querySelectorAll('.pv-filter-disclosure[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pv-filter-disclosure[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-header-localization"] && !Shopify.designMode) return;
  try {
    (function(){var pill=document.querySelector('.pv-langpill[data-pv-cur-lang]');if(!pill)return;var lang=pill.dataset.pvCurLang||'';var cur=pill.dataset.pvCurCountry||'';var want=null;var btn=pill.querySelector('button[data-pv-lang-cc][lang="'+lang+'"]');if(btn)want=btn.dataset.pvLangCc;if(!want||!cur||want===cur)return;var key='pvcc:'+lang+':'+want;try{if(sessionStorage.getItem(key))return;sessionStorage.setItem(key,'1');}catch(e){}var form=pill.querySelector('form');if(!form)return;var cc=form.querySelector('[data-pv-cc]');if(cc)cc.value=want;var hidden=document.createElement('input');hidden.type='hidden';hidden.name='language_code';hidden.value=lang;form.appendChild(hidden);form.submit();})();
document.addEventListener('click',event=>{const langBtn=event.target.closest?.('.pv-langpill-panel button[data-pv-lang-cc]');if(langBtn){const form=langBtn.closest('form');const cc=form&&form.querySelector('[data-pv-cc]');if(cc&&langBtn.dataset.pvLangCc)cc.value=langBtn.dataset.pvLangCc;}document.querySelectorAll('.pv-langpill[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pv-langpill[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
document.addEventListener('toggle',event=>{if(event.target.matches?.('.pv-langpill')&&event.target.open){document.querySelectorAll('.pv-nav-item[open]').forEach(menu=>menu.open=false);}if(event.target.matches?.('.pv-nav-item')&&event.target.open){document.querySelectorAll('.pv-langpill[open]').forEach(menu=>menu.open=false);}},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-pv-quick-open]');
  if (opener) {
    event.preventDefault();
    const card = opener.closest('.pv-art-card');
    const panel = card && card.querySelector('[data-pv-quick]');
    if (!panel) return;
    document.querySelectorAll('[data-pv-quick]:not([hidden])').forEach((p) => { if (p !== panel) p.hidden = true; });
    panel.hidden = false;
    return;
  }

  const closer = event.target.closest('[data-pv-quick-close]');
  if (closer) {
    const panel = closer.closest('[data-pv-quick]');
    if (panel) panel.hidden = true;
    return;
  }

  const size = event.target.closest('[data-pv-size]');
  if (size) {
    const panel = size.closest('[data-pv-quick]');
    panel.querySelectorAll('[data-pv-size]').forEach((b) => {
      b.classList.toggle('is-active', b === size);
      b.setAttribute('aria-selected', b === size ? 'true' : 'false');
    });
    panel.querySelector('[data-pv-quick-total]').textContent = size.dataset.price;
    panel.querySelector('[data-pv-atc]').dataset.pvAtc = size.dataset.variant;
    return;
  }

  if (!event.target.closest('[data-pv-quick]')) {
    document.querySelectorAll('[data-pv-quick]:not([hidden])').forEach((p) => { p.hidden = true; });
  }
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pv-atc]');
  if (!button) return;
  event.preventDefault();
  if (button.dataset.busy === '1') return;
  button.dataset.busy = '1';
  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.pvAtc), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    button.textContent = 'Added';
    window.location.href = '/cart';
  } catch (error) {
    button.textContent = label;
    button.disabled = false;
    button.dataset.busy = '';
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pv-size-scale"] && !Shopify.designMode) return;
  try {
    function initPrintavelleScale(scope=document){scope.querySelectorAll('[data-pv-scale]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const height=root.querySelector('[data-height]'),size=root.querySelector('[data-size]');function draw(){const h=Number(height.value),[w,p]=size.value.split(',').map(Number);if(!height.checkValidity()||!Number.isFinite(h)||h<100||h>220)return;root.querySelector('[data-person]').setAttribute('transform',`translate(40 ${225-h}) scale(${h/174})`);const rect=root.querySelector('[data-print]');rect.setAttribute('x',162.5-w/2);rect.setAttribute('y',105-p/2);rect.setAttribute('width',w);rect.setAttribute('height',p);root.querySelector('[data-size-label]').textContent=`${w} × ${p} cm`;root.querySelector('[data-height-label]').textContent=`${h} cm`;}height.addEventListener('input',draw);size.addEventListener('change',draw);draw();});}initPrintavelleScale();document.addEventListener('shopify:section:load',event=>initPrintavelleScale(event.target));
  } catch(e) { console.error(e); }
})();

})();
